
import Vue from 'vue';
import LoginAndSignupForm from '@customer/components/login-and-sign-up/LoginAndSignupForm.vue';
import Modal from '@core/components/UI/Modal.vue';

interface Methods {
  close: () => void;
}

interface Computed {
  isLoggedIn: boolean;
  isModalVisible: boolean;
}

interface Props {
  hideSignup: boolean;
}

export default Vue.extend<unknown, Methods, Computed, Props>({
  components: {
    LoginAndSignupForm,
    Modal,
  },
  props: {
    hideSignup: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    isLoggedIn() {
      return !!this.$store.state.customer.token;
    },
    isModalVisible() {
      return this.$store.state.customer.modalVisible;
    },
  },
  watch: {
    // Close modal if user is logged in
    isLoggedIn: {
      immediate: true,
      handler(value) {
        if (value) {
          this.close();
        }
      },
    },
  },
  methods: {
    close() {
      this.$nextTick(() => {
        this.$store.commit('customer/setLoginFormType', 'check');
        this.$store.commit('customer/setModalState', false);
      });
    },
  },
});
